import type React from 'react';

import { convertFromStringToBool } from '@hooks/useFilterObject';

import type { VerktoyFilterState } from '@src/types/stateTypes';

import FilterSearch from '@helsenorge/filter/components/filter/filter-search';

interface VerktoyFilterSearchProps {
  searchValueUrl: string | undefined;
  setSearchValueUrl: (val: string) => void;
  searchQuery: string | undefined;
  setSearchQuery: (val: string) => void;
  stotterAnonymOppstartChecked: string | undefined;
  fagomraderValgt: string[];
  malgrupperValgt: string[];
  verktoytyperValgt: string[];
  valgtSortering: string | undefined;
  valgtSorterstigende: string | undefined;
  onSearchClicked: (filters: VerktoyFilterState) => void;
}

const VerktoyFilterSearch: React.FC<VerktoyFilterSearchProps> = ({
  searchValueUrl,
  setSearchValueUrl,
  searchQuery,
  setSearchQuery,
  stotterAnonymOppstartChecked,
  fagomraderValgt,
  malgrupperValgt,
  verktoytyperValgt,
  valgtSortering,
  valgtSorterstigende,
  onSearchClicked: onSearchCalled,
}) => (
  <FilterSearch
    defaultValue={searchValueUrl ?? ''}
    onChange={e => {
      setSearchValueUrl(e.target.value);
      setSearchQuery(e.target.value);
    }}
    onSearch={() => {
      const kombinertSokOgFilter: VerktoyFilterState = {
        SokeString: searchValueUrl ?? '',
        IsAnonymCheckboxChecked: convertFromStringToBool(stotterAnonymOppstartChecked),
        Fagomrader: fagomraderValgt,
        Malgrupper: malgrupperValgt,
        VerktoyTyper: verktoytyperValgt,
        Sortering: valgtSortering,
        SorterStigende: valgtSorterstigende,
      };
      onSearchCalled(kombinertSokOgFilter);
      setSearchValueUrl(searchQuery ?? '');
    }}
  />
);

export default VerktoyFilterSearch;
